import FooterTop from './FooterTop';
import FooterMiddle from './FooterMiddle';
import FooterBottom from './FooterBottom';

function Footer(props) {
    return (
        <footer id="footer">
            <FooterTop />
            <FooterMiddle />
            <FooterBottom />
        </footer>
    );
}

export default Footer;